export default __webpack_public_path__ + "static/media/water.ca1ec609.mp3";